import MetaMixin from './MetaMixin'

export default {
    mixins: [
        MetaMixin
    ]
}